import FormComponent from '../utils/FormComponent';
import * as blockUtils from '../../utils/BlockUtils';
import * as api from '../../api/site-management-api';
import i18next from 'i18next';
import * as viewUtils from '../../utils/view-utils';
import ModalDialog from '../utils/ModalDialog';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import {React} from 'react';
import PropTypes from 'prop-types';
import SimplifiedCheckbox from '../utils/SimplifiedCheckbox';

class SiteManagementForm extends FormComponent {
  constructor(props) {
    super(props);

    this.getUsers = this.getUsers.bind(this);
    this.updateUserAccess = this.updateUserAccess.bind(this);

    this.pageNumber = 0;
    this.elementsCount = 10;
    this.sortingName = 'id';
    this.sortingType = 'ASC';
    this.searchPhrase = '';
  }

  initialState() {
    return {
      site: this.props.site,
      users: [],
      totalElements: 0,
      totalPages: 0,
      dialogId: this.props.dialogId,
      tableId: this.props.tableId,
      showChangesAppliedPrompt: false,
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers(
      pageNumber = this.pageNumber,
      elementsCount = this.elementsCount,
      sortingName = this.sortingName,
      sortingType = this.sortingType,
      searchPhrase = this.searchPhrase,
  ) {
    const data = {
      page: pageNumber,
      size: elementsCount,
      query: searchPhrase,
      sort: `${sortingName},${sortingType.toLowerCase()}`,
    };

    blockUtils.blockUI();
    api.getAvailableUsers(this.props.site.id, data).then((response) => {
      const users = response.data.content;

      blockUtils.unblockUI();
      this.setState({
        users: users,
        totalElements: response.data.totalElements,
        totalPages: response.data.totalPages,
      });
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  updateUserAccess(updatedUser) {
    const oldUser = this.state.users.find((user) => user.id === updatedUser.id);
    oldUser.hasAccess = !oldUser.hasAccess;

    const users = this.state.users.map((user) => user.id === oldUser.id ? oldUser : user);
    this.setState({users: users});

    const userList = [oldUser];

    blockUtils.blockUI();
    api.updateUserAccessToSite(this.props.site.id, userList).then((response) => {
      blockUtils.unblockUI();

      if (response.status !== 202) {
        window.showAlert(i18next.t('error'), response.statusText);
        return;
      }

      this.showChangesAppliedPrompt();
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  showChangesAppliedPrompt() {
    this.setState({showChangesAppliedPrompt: true});

    setTimeout(() => {
      this.setState({showChangesAppliedPrompt: false});
    }, 2000);
  }

  render() {
    let title = i18next.t('sites.site_management.title', {name: this.state.site.name, id: this.state.site.id});
    title = title.replace('amp;', '');

    return (
      <ModalDialog
        customClass="site-management-form"
        modalTitle={title}
        dialogId={this.state.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        onSubmit={this.updateUserAccess}
        showSave={false}
        showChangesAppliedPrompt={this.state.showChangesAppliedPrompt}
      >

        <div className="table-container">
          <ReduxDataTable
            {...this.state}
            tableId={'site-management-form-table'}
            getData={this.getUsers}
            notSortable={[3, 4]}
          >
            <thead>
              <tr role="row" className="odd heading">
                <th>ID</th>
                <th data-sort="username">{i18next.t('users.attrs.login')}</th>
                <th data-sort="email">{i18next.t('users.attrs.email')}</th>
                <th>{i18next.t('users.attrs.role')}</th>
                <th>{i18next.t('sites.site_management.attrs.access')}</th>
              </tr>
            </thead>
            <tbody>
              {this.state.users.map((user) => {
                return (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.username ? user.username : user.email}</td>
                    <td>{user.email}</td>
                    <td>{i18next.t([`users.roles.${user.role}`])}</td>
                    <td>
                      <SimplifiedCheckbox
                        fieldId={user.id + ''}
                        value={user.hasAccess}
                        onChange={() => this.updateUserAccess(user)}
                        styling={{margin: '5px'}}
                      />
                    </td>
                  </tr>);
              })}
            </tbody>
          </ReduxDataTable>
        </div>
      </ModalDialog>
    );
  }
}

SiteManagementForm.propTypes = {
  site: PropTypes.object,
  dialogId: PropTypes.string,
  totalElements: PropTypes.number,
  totalPages: PropTypes.number,
};

export default SiteManagementForm;
